import i18n from '@/lang';
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _typeof from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import router from '../router';
import store from '../store';
import vue from 'vue';
import { baseUrl } from '@root/_target.js';
var timer;
var HttpRequest = axios.create({
  baseURL: baseUrl,
  timeout: 12000
});
HttpRequest.interceptors.request.use(function (config) {
  // 添加token
  if (!config.headers) {
    config.headers = {};
  }
  config.headers.Authorization = store.state.globalStore.Authorization;
  if (config.method !== 'get') {
    var user = store.state.globalStore.user;
    var ctoken = user.csrfToken || 'csrfToken'; // 后端固定值
    if (user && Object.keys(user).length > 0) {
      if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
        // 判断参数是否经过stringify转换
        if (_typeof(config.data) === 'object') {
          config.data.ctoken = ctoken;
        } else {
          if (config.data) {
            config.data += '&ctoken=' + ctoken;
          } else {
            config.data = 'ctoken=' + ctoken;
          }
        }
      } else if (config.method === 'delete') {
        if (config.url.indexOf('?') === -1) {
          config.url += '?ctoken=' + ctoken;
        } else {
          config.url += '&ctoken=' + ctoken;
        }
        // delete方法，拼接数组才能正常删除
        if (config.params && config.params.ids) {
          config.url += "&ids=".concat(config.params.ids);
          delete config.params.ids;
        }
      }
    }
  }
  return config;
});
HttpRequest.interceptors.response.use(function (res) {
  var data = res.data;
  switch (res.status) {
    case 200:
      if (!data.success && (data.message === i18n.tc("1") || data.message === i18n.tc("2"))) {
        store.commit('globalStore/_user', {});
        vue.$vux.toast.text(i18n.tc("3"));
        router.push('/login');
      }
      if (!data.success && data.message === i18n.tc("4")) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          return store.dispatch('globalStore/_ApiSession');
        }, 200);
      }
      return data;
  }
}, function (err) {
  switch (err.response.status) {
    case 404:
      vue.$vux.toast.text('404 err');
      break;
    case 500:
      vue.$vux.toast.text('500 err');
      break;
    default:
      vue.$vux.toast.text('unknow err');
  }
  return Promise.reject(err);
});
export default HttpRequest;